import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-image">
          <img src={`${process.env.PUBLIC_URL}/psi-symbol.png`} alt="Simbolo Psi" />
        </div>
        <h1>Lezioni di italiano che vanno oltre la grammatica</h1>
        <p className="hero-subtitle">
          Tecniche personalizzate per far emergere il tuo potenziale
        </p>
        <blockquote className="hero-quote">
          <p className="quote-latin">Sed omnia praeclara tam difficilia, quam rara sunt.</p>
          <p className="quote-italian">Tutto ciò che è eccellente è tanto difficile quanto raro</p>
          <cite>— Baruch Spinoza</cite>
        </blockquote>
      </div>
    </section>
  );
}

export default Hero;
